import { useToggleLivePreview } from 'components/practice/Settings/components/HealthcareProgram/lib/livePreviewEvents';
import Button from 'components/shared/Button/Button';
import Dot from 'components/shared/Dot/Dot';
import Typography from 'components/shared/Typography/Typography';

const LivePreviewHeader = () => {
  const toggle = useToggleLivePreview();
  return (
    <div className="flex h-12 items-center justify-between gap-3 border-0 border-b border-solid border-b-neutral-200 bg-white px-4 py-0">
      <div className="flex items-center gap-2">
        <Typography size="medium" weight="medium" className="shrink-0">
          Live Preview
        </Typography>
        <Dot size="sm" color="danger" />
      </div>
      <Button
        icon="close-linear"
        size="sm"
        variant="link"
        iconSize={18}
        color="neutral"
        iconShade={700}
        onClick={toggle}
        aria-label="Close live preview"
      />
    </div>
  );
};

export default LivePreviewHeader;
